export default __webpack_public_path__ + "static/saucesomemockup-8477fda728796c1954bf30cf0a258beb.png";